const calpak = window.calpak

const pauseGIFs = () => {
    const gifPictures = document.querySelectorAll('picture source[srcset*=".gif"]');
    // Loop through and access the parent <picture> element for each matched <source>
    gifPictures.forEach(source => {
        const pictureElement = source.closest('picture');
        pictureElement.querySelectorAll('source').forEach(source => {
            source.srcset = source.srcset.replace(/\.gif\?/g, '.gif?format=jpg&');
        })
    });
}
calpak.pauseGIFs = pauseGIFs

// Pause all animated gifs after 5 seconds if prefers-reduced-motion: reduce
const checkReducedMotionPauseGIFs = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setTimeout(() => calpak.pauseGIFs(), 5000);
    }
}
calpak.checkReducedMotionPauseGIFs = checkReducedMotionPauseGIFs

calpak.checkReducedMotionPauseGIFs()



